import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "flex w-full justify-between items-center pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, "Pembatalan Paket", -1)
const _hoisted_3 = { class: "background-grey-lighten-5 px-5 py-5 mb-4 rounded-lg" }
const _hoisted_4 = { class: "flex flex-wrap lg:flex-nowrap w-full justify-between" }
const _hoisted_5 = { class: "py-2 w-full lg:w-auto mr-2" }
const _hoisted_6 = { class: "font-bold text-2xl break-all" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "color-primary" }
const _hoisted_9 = { class: "flex flex-col  items-center" }
const _hoisted_10 = { class: "lg:w-auto w-full py-2 flex items-center" }
const _hoisted_11 = { class: "mr-2" }
const _hoisted_12 = { class: "px-2 inline-block rounded-md font-semibold text-base break-all red-tag" }
const _hoisted_13 = { class: "grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2" }
const _hoisted_14 = { class: "lg:mb-0 md:mb-0 mb-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-1 color-blue-grey" }, "Pengirim", -1)
const _hoisted_16 = { class: "font-semibold mb-1 break-all" }
const _hoisted_17 = { class: "font-semibold mb-1 break-all" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-1 color-blue-grey" }, "Penerima", -1)
const _hoisted_20 = { class: "font-semibold mb-1 break-all" }
const _hoisted_21 = { class: "font-semibold mb-1 break-all" }
const _hoisted_22 = { class: "lg:hidden md:hidden block" }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-2 color-blue-grey" }, "Total Biaya Tambahan : ", -1)
const _hoisted_24 = { class: "color-red font-semibold" }
const _hoisted_25 = { class: "grid-cols-2 gap-2 lg:grid md:grid hidden" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-2 mt-4 color-blue-grey" }, "Total Biaya Tambahan : ", -1)
const _hoisted_27 = { class: "color-red font-semibold" }
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "text-sm color-blue-grey" }, "Alasan Pembatalan", -1)
const _hoisted_29 = { class: "text-sm" }
const _hoisted_30 = { class: "flex items-center p-4 w-full justify-between" }
const _hoisted_31 = /*#__PURE__*/_createVNode("p", { class: "font-normal text-lg" }, "List Barang", -1)
const _hoisted_32 = { class: "font-normal text-lg" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Total ")
const _hoisted_34 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_35 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_36 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_37 = { class: "pt-5" }
const _hoisted_38 = { class: "flex gap-4 justify-start" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isShowModal,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowModal = $event)),
    dismissableMask: true,
    modal: true,
    style: {width: '50vw'},
    onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideDialog())),
    class: "dialog-confirm confirm-cancel-package-dialog"
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("i", {
          class: "pi pi-times text-black cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideDialog()))
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_37, [
        _createVNode("div", _hoisted_38, [
          _createVNode(_component_Button, {
            class: _ctx.submitType === 0 ? 'btn-primary font-semibold px-10 text-white' : 'btn-red font-semibold px-10 text-white',
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.submitType === 0 ? 'Tetap Kirim Paket' : 'Batalkan Paket'), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_Button, {
            class: "btn-secondary text-black font-semibold px-10 py-1",
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideDialog()))
          }, {
            default: _withCtx(() => [
              _hoisted_39
            ]),
            _: 1
          })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("section", null, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("p", _hoisted_6, "#" + _toDisplayString(_ctx.dataSource?.Resi), 1),
              _createVNode("span", _hoisted_7, [
                _createVNode("p", _hoisted_8, _toDisplayString(_ctx.dataSource?.KotaAsalNama) + " - " + _toDisplayString(_ctx.dataSource?.KotaTujuanNama), 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode("p", _hoisted_12, _toDisplayString(_ctx.dataSource?.StatusPengirimanStatus), 1)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("p", _hoisted_16, _toDisplayString(_ctx.dataSource?.NamaPengirim), 1),
              _createVNode("p", _hoisted_17, _toDisplayString(`${_ctx.dataSource?.AlamatPengirim} (${_ctx.dataSource?.HpPengirim})`), 1)
            ]),
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode("p", _hoisted_20, _toDisplayString(_ctx.dataSource?.NamaPenerima), 1),
              _createVNode("p", _hoisted_21, _toDisplayString(`${_ctx.dataSource?.AlamatPenerima} (${_ctx.dataSource?.HpPenerima})`), 1),
              _createVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode("p", _hoisted_24, "Rp. " + _toDisplayString(new Number(_ctx.dataSource?.BiayaTambahan).toLocaleString("id-ID")), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode("div", null, [
              _hoisted_26,
              _createVNode("p", _hoisted_27, "Rp. " + _toDisplayString(new Number(_ctx.dataSource?.BiayaTambahan).toLocaleString("id-ID")), 1)
            ])
          ])
        ]),
        _createVNode(_component_Card, { class: "card-no-shadow card-p-0 mb-5 px-4 py-3" }, {
          content: _withCtx(() => [
            _hoisted_28,
            _createVNode("p", _hoisted_29, _toDisplayString(_ctx.dataSource?.StatusPengirimanKeterangan), 1)
          ]),
          _: 1
        }),
        (_ctx.dataSource?.TransPengirimanDetails)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              class: "card-no-shadow card-p-0 mb-5"
            }, {
              content: _withCtx(() => [
                _createVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode("p", _hoisted_32, [
                    _hoisted_33,
                    _createVNode("b", null, _toDisplayString(_ctx.dataSource?.TransPengirimanDetails.length) + " Koli", 1)
                  ])
                ]),
                _createVNode(_component_DataTable, {
                  value: _ctx.dataSource?.TransPengirimanDetails,
                  class: "table-og body-td-x-0",
                  responsiveLayout: "scroll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, { header: "Satuan" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", _hoisted_34, _toDisplayString(slotProps.data.Berat) + " Kg", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Kategori Barang" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", _hoisted_35, _toDisplayString(slotProps.data.KategoriBarangNama), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Biaya Barang" }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("p", _hoisted_36, "Rp. " + _toDisplayString(new Number(slotProps.data.TotalHarga).toLocaleString("id-ID")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}